import { config } from './config';

export type LeadFormPayload = {
  fullName: string;
  workEmail: string;
  company: string;
  jobTitle: string;
  phone: string;
  hiringGoals: string;
  marketingOptIn: boolean;
};

export class LeadFormSubmissionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LeadFormSubmissionError';
  }
}

function toFormBody(payload: LeadFormPayload): string {
  const params = new URLSearchParams();
  params.set('fullName', payload.fullName);
  params.set('workEmail', payload.workEmail);
  params.set('company', payload.company);
  params.set('jobTitle', payload.jobTitle);
  params.set('phone', payload.phone);
  params.set('hiringGoals', payload.hiringGoals);
  params.set('marketingOptIn', payload.marketingOptIn ? 'true' : 'false');
  return params.toString();
}

export async function submitLeadForm(payload: LeadFormPayload): Promise<void> {
  const endpoint = config.leadFormUrl.trim();

  if (!endpoint) {
    throw new LeadFormSubmissionError(
      'Lead form is not configured. Add REACT_APP_LEAD_FORM_URL to .env and restart the dev server.',
    );
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    redirect: 'follow',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
    body: toFormBody(payload),
  });

  let result: { success?: boolean; error?: string } = {};

  try {
    result = await response.json();
  } catch {
    if (response.ok) return;
    throw new LeadFormSubmissionError('Something went wrong. Please try again in a moment.');
  }

  if (result.success === false) {
    throw new LeadFormSubmissionError(result.error || 'Something went wrong. Please try again.');
  }

  if (!response.ok) {
    throw new LeadFormSubmissionError('Something went wrong. Please try again in a moment.');
  }
}
